export const ROLE_PATH = {
	user: '/user',
	admin: '/admin',
	hr: '/hr',
	accountant: '/accountant',
	superAdmin: '/superAdmin',
	manager: '/manager',
	teamleader: '/teamleader',
	executive: '/executive',
	telecaller: '/telecaller',
};

export const ROLE = {
	admin: 'admin',
	user: 'user',
	hr: 'HR',
	accountant: 'accountant',
	attendance: 'attendance',
	manager: 'manager',
	teamleader: 'teamleader',
	telecaller: 'telecaller',
	executive: 'executive',
};
